import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowheadDown = (props: SvgIconT.Props) => <SvgIcon {...props} viewBox="0 0 20 20" paths={['M10 13L5 8h10z']} />;

export default ArrowheadDown;
